import { render, staticRenderFns } from "./DeslogarAgente.vue?vue&type=template&id=2d659e5d&scoped=true&"
import script from "./DeslogarAgente.vue?vue&type=script&lang=js&"
export * from "./DeslogarAgente.vue?vue&type=script&lang=js&"
import style0 from "./DeslogarAgente.vue?vue&type=style&index=0&id=2d659e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d659e5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VForm,VRow,VSelect,VSheet,VSkeletonLoader,VSwitch})
